import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../src/common/SafeIcon';

const { FiUsers, FiBriefcase, FiScale, FiBarChart, FiShield, FiHome } = FiIcons;

export const TargetAudience: React.FC = () => {
  const audiences = [
    { icon: FiUsers, label: "Financial Advisors", desc: "Equip yourself to answer client questions." },
    { icon: FiBriefcase, label: "Wealth Managers", desc: "Integrate assets into holistic plans." },
    { icon: FiHome, label: "RIAs & Planners", desc: "Navigate fiduciary responsibilities." },
    { icon: FiBarChart, label: "Portfolio Managers", desc: "Understand correlation & allocation." },
    { icon: FiScale, label: "Compliance Teams", desc: "Define boundaries & policies." },
    { icon: FiShield, label: "Asset Managers", desc: "Evaluate institutional adoption." },
  ];

  return (
    <section className="py-24 bg-slate-50 relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_left,_var(--tw-gradient-stops))] from-brand-100/40 via-transparent to-transparent"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-serif font-bold text-slate-900 mb-4">Who It's For</h2>
          <p className="text-slate-600 max-w-2xl mx-auto">Designed for professionals across the wealth management spectrum who need clarity, not hype.</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {audiences.map((item, idx) => (
            <div key={idx} className="group bg-white p-6 rounded-xl border border-slate-200 shadow-sm hover:shadow-md hover:border-brand-200 transition-all duration-300">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-12 h-12 bg-slate-50 text-slate-600 group-hover:bg-brand-50 group-hover:text-brand-600 rounded-lg flex items-center justify-center transition-colors">
                  <SafeIcon icon={item.icon} className="w-6 h-6" />
                </div>
                <h3 className="font-semibold text-slate-900 text-lg group-hover:text-brand-900 transition-colors">{item.label}</h3>
              </div>
              <p className="text-slate-500 text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};